import { statusComponent } from './status.component';

export const statusStateName = 'app.status';

export const statusState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    name: statusStateName,
    url: '/status/:orderId?id?token?birthday',
    component: statusComponent.name,
    params: {
      id: null,
      token: null,
      birthday: null,
      orderId: {
        value: '',
        squash: true,
      },
    },
  });
};



// WEBPACK FOOTER //
// ./src/app/components/status/status.state.js